import { readToken } from "Helpers/Token";

export const baseURL = process.env.REACT_APP_BACKEND_BASE_URL;
export const headers = {
  Authorization: `Bearer ${readToken()}`,
  "Content-Type": "application/json",
  dataType: 'json',
};
